
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiShipTanker as ObiShipTankerElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ship-tanker.js';
 
 
 

 
 export const ObiShipTanker = createComponent({
   react: React,
   tagName: 'obi-ship-tanker',
   elementClass: ObiShipTankerElement,
   events: {
     
   }
  });
 
 